export default __webpack_public_path__ + "f8bb388ee488b9c86ad8865fde1af68c.jpg";